import { ShiftId } from '@wilson/api/gateway';
import { UserId } from '@wilson/shift-timeline/state';

export function shiftIdToUserIdMap(
  originalUserIdToShiftIdsMap: Partial<Record<UserId, ShiftId[]>>,
): Map<ShiftId, UserId | null> {
  const map = new Map<ShiftId, UserId | null>();

  Object.keys(originalUserIdToShiftIdsMap).reduce((normalizedMap, userId) => {
    const shiftIds = originalUserIdToShiftIdsMap[userId];
    if (shiftIds) {
      shiftIds.forEach((shiftId) => {
        if (userId === 'null') {
          normalizedMap.set(shiftId, null);
        } else {
          normalizedMap.set(shiftId, userId);
        }
      });
    }
    return normalizedMap;
  }, map);

  return map;
}
